/** The radius ladder — docs/sprocket-design-language.md §4. */
export const RADIUS = {
    /** Controls, chips, inputs. */
    sm: 6,
    /** Cards, menus. */
    md: 8,
    /** Dialogs, the command palette. */
    lg: 10,
    /** Avatars. */
    pill: 999,
};
//# sourceMappingURL=radius.js.map